// extracted by mini-css-extract-plugin
module.exports = {"market":"Market_market__1gbi_","table":"Market_table__1ZTfH","row":"Market_row__2vDKx","col":"Market_col__3NyxG","foot":"Market_foot__35ryw","arrow":"Market_arrow__z_y-B"};